<h2 mat-dialog-title class="pl-4 pt-4">
  Review & Sign: Business Associate Agreement
  <span class="logout">
    <a [href]="logoutHref" tabindex="-1"> Sign Out </a>
  </span>
</h2>
<div class="pl-4">
  A Business Associate Agreement (BAA) document is a mandatory acknowledgement
  mandated by HIPAA prior to using the Presence Platform.
</div>
<mat-dialog-content class="h-100">
  <iframe [src]="baaSignUrl" frameborder="0" class="h-100 w-100"></iframe>
</mat-dialog-content>
